<div
    *ngIf="entityInternal"
    class="agpr-targetingResults-cardWrapper agpr-affiliateCard agpr-contextMenu-parent"
    [ngClass]="{
        'agpr-targetingResults-cardWrapper-focused': selectedOutletId === entityInternal.id
    }"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="agpr-targetingResults-card card"
        (agprClickUnless)="onCardClicked(entityInternal)"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        [attr.aria-label]="'Discover.universal.affiliateCard.label' | localize: {name: entityInternal.name}"
        (keydown)="onKeydown($event)"
    >
        <div class="agpr-targetingResults-card-checkbox">
            <agpr-checkbox
                [id]="id + '_checkbox'"
                [disabled]="disableSelection"
                [value]="entityInternal"
                [hiddenLabel]="entityInternal.name"
                [(ngModel)]="selectedResults"
                (onChange)="checkboxClick()"
            ></agpr-checkbox>
        </div>

        <div class="agpr-targetingResults-card-thumbnail">
            <img
                class="agpr-targetingResults-card-thumbnail-img agpr-affiliateCard"
                [agprImageSrc]="entityInternal.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                alt=""
                [agprDefaultImage]="imageDefault.SMALL_OUTLET"
            />
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                role="img"
                class="fa-regular fa-duotone fa-check agpr-targetingResults-card-thumbnail-checkmark"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            ></span>
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                class="agpr-targetingResults-card-thumbnail-number"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            >
                {{ listMemberships.length }}
            </span>
        </div>

        <div class="agpr-targetingResults-card-description agpr-targetingResults-minicard-description-container agpr-affiliateCard-topRow">
            <div class="agpr-targetingResults-minicard-description-row">

                <div class="agpr-targetingResults-card-description-profile">
                    <a
                        class="agpr-targetingResults-card-description-profile-name"
                    >
                        {{ entityInternal.name }}
                    </a>
                    <span
                        role="img"
                        class="fa-kit fa-agpr-outlet-solid agpr-targetingResults-card-description-profile-icon"
                        [attr.aria-label]="'Discover.universal.outletLinkIcon'"
                    ></span>
                </div>
                <div class="agpr-targetingResults-minicard-spacer"></div>
                <div
                    *ngIf="reachValue"
                    class="agpr-targetingResults-card-details-circulation .agpr-affiliateCard"
                    [pTooltip]="(reachValue | number) + ' ' + (reachUnit | localize)"
                    tooltipPosition="top"
                >
                    {{reachValue | number}}
                </div>
                <div class="agpr-targetingResults-card-details-badges">
                    <span
                        *ngFor="let badge of entityInternal.badges"
                        role="img"
                        class="agpr-targetingResults-card-badges {{badge.iconClass}}"
                        [agprTooltip]="badge.tooltip"
                        tooltipPosition="top"
                    ></span>
                </div>
            </div>
            <div class="agpr-affiliateCard-bottomRow">
                <div
                    *ngIf="entityInternal.mediaTypes && entityInternal.mediaTypes.length > 0"
                    class="agpr-affiliateCard-media"
                >
                    <span
                        *ngFor="let mediaType of entityInternal.mediaTypes; let last = last"
                    >
                        {{ mediaType.displayString | localize }}{{ !last ? ', ' : ''}}
                    </span>
                </div>
                <div
                    *ngIf="entityInternal.coverageFocus"
                    class="agpr-affiliateCard-coverage"
                >
                    {{entityInternal.coverageFocus.displayString}}
                </div>
            </div>
        </div>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            (click)="onCardClicked(entityInternal)"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
            tooltip="Discover.entityProfile.expand"
        ></agpr-button>
        <agpr-button
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-user-plus'"
            tooltip="Discover.targeting.actions.manageLists"
            (click)="openManageListDialog(entityInternal)"
            class="agpr-targetingResults-cardWrapper-contextMenu-button"
        ></agpr-button>
    </div>
</div>
